import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';

import { TransactionalTextField } from '@/components/shared/transactionalTextField';

import { Icon } from '../shared/icon';
import { Tag } from '../tag';

export const TagsSection = ({
  initialTags,
  tags = {},
  keepOriginalTags,
  setKeepOriginalTags,
  onChange,
  provider,
}: {
  tags: Record<string, string> | undefined;
  initialTags: Record<string, string>;
  keepOriginalTags: boolean;
  setKeepOriginalTags?: (value: boolean) => void;
  onChange: (tags: Record<string, string>) => void;
  provider?: string;
}) => {
  return (
    <Stack className='w-full px-[40px]' gap='24px'>
      {setKeepOriginalTags && (
        <Box className='flex justify-between items-center'>
          <Typography className='font-semibold' variant='body1'>
            {`Keep original ${provider === Provider.Gcp ? 'labels' : 'tags'}`}
          </Typography>
          <Switch
            size='small'
            checked={keepOriginalTags}
            onChange={() => {
              setKeepOriginalTags(!keepOriginalTags);
            }}
          />
        </Box>
      )}
      {keepOriginalTags &&
        initialTags &&
        Object.keys(initialTags).length > 0 && (
          <Stack className='w-full' gap='8px' direction='row' flexWrap='wrap'>
            {Object.entries(initialTags).map((entry) => (
              <Tag
                variant='secondary'
                key={entry[0]}
                content={entry.filter((x) => x).join('=')}
              />
            ))}
          </Stack>
        )}
      {!keepOriginalTags && (
        <Stack gap='40px'>
          {Object.entries(tags).length > 0 && (
            <Stack gap='24px'>
              {Object.entries(tags).map(([key, value]) => (
                <Stack
                  key={key}
                  direction='row'
                  gap='24px'
                  alignItems='end'
                  width='560px'
                >
                  <FormControl variant='outlined' fullWidth>
                    <FormLabel>Key</FormLabel>
                    <TransactionalTextField
                      initValue={key}
                      onChange={(newKey) => {
                        if (key !== newKey) {
                          const newState = {
                            ...tags,
                            [newKey]: tags[key],
                          };

                          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                          delete newState[key];
                          onChange(newState);
                        }
                      }}
                    />
                  </FormControl>
                  <FormControl variant='outlined' fullWidth>
                    <FormLabel>Value</FormLabel>
                    <TransactionalTextField
                      initValue={value}
                      onChange={(newValue) => {
                        const newState = {
                          ...tags,
                          [key]: newValue,
                        };
                        onChange(newState);
                      }}
                    />
                  </FormControl>
                  <Stack height='100%'>
                    <Icon
                      iconClass='material-symbols-close-rounded'
                      onClick={() => {
                        const newState = {
                          ...tags,
                        };

                        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete newState[key];
                        onChange(newState);
                      }}
                    />
                  </Stack>
                </Stack>
              ))}
            </Stack>
          )}
          <Button
            sx={{ width: 'max-content' }}
            variant='outlined'
            onClick={() => onChange({ ...tags, '': '' })}
          >
            {`+ Add ${provider === Provider.Gcp ? 'Label' : 'Tag'}`}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
